module.exports = __webpack_public_path__ + "img/PRSI2.59aabfa8.png";